import { render } from "./DocumentHTMLConfig.vue?vue&type=template&id=ad8d70a6"
import script from "./DocumentHTMLConfig.vue?vue&type=script&lang=js"
export * from "./DocumentHTMLConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/flow/evaluate/DocumentHTMLConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad8d70a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad8d70a6', __exports__)) {
    api.reload('ad8d70a6', __exports__)
  }
  
  module.hot.accept("./DocumentHTMLConfig.vue?vue&type=template&id=ad8d70a6", () => {
    api.rerender('ad8d70a6', render)
  })

}


export default __exports__